<script>
export default {
  name: 'UIModalController',
  inject: ['modal'],
  created () {
    this.modal._childModal = this.$parent;
  },
  render (h) {
    return h('div', [this.$scopedSlots.default(this.modal)]);
  },
};
</script>
